import React from "react";
import Header from "../../Frontend/Shared/Header/Header";
import Sidebar from "../../Frontend/Shared/Sidebar";
import Footer from "../../Frontend/Shared/Footer/Footer";
import ErnakulamRouting from "./ErnakulamRouting";

const ErnakulamLayout = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <Header benchId={benchId} benchName={benchName} benchCode={benchCode} />
      <div className="main-center-area">
        <div className="container-fluid">
          <div className="row">
            <Sidebar benchId={7} calendarId={benchId} />
            <ErnakulamRouting benchId={benchId} benchName={benchName} />
          </div>
        </div>
      </div>
      <Footer benchId={benchId} />
    </>
  );
};

export default ErnakulamLayout;
